import { connect } from 'react-redux';
import TinyClubConfig from '../views/tiny/TinyClubConfig';

function mapStateToProps(state, ownProps) {
  return {
    // 如果需要 Redux state，可以在這裡添加
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 如果需要 Redux actions，可以在這裡添加
});

const TinyClubConfigContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyClubConfig);

export default TinyClubConfigContainer;


